// Pollution just for ICE (Internal Combustion Engine)
import { zipWith } from 'lodash';
import { createSelector } from 'reselect';

import {
  // ICE Items
  getCNGEmissionsPerKm,
  getDieselEmissionsPerKm,
  getGasolineEmissionsPerKm,
} from './carbonEmissionRate';

// Gasoline travel lives not in vehicleDistanceTraveled because of a circular dependency.
import {
  getUtilizationCNG,
  getUtilizationDiesel,
  getUtilizationGasoline,
} from '../vehicleStock';


export const getGasolineEmissionsTotal = createSelector([
  getUtilizationGasoline,
  getGasolineEmissionsPerKm,
],
  (distanceSeries, emissionsSeries, ) => {

    // One of the series is longer than the other
    const delta = emissionsSeries.length - distanceSeries.length;
    const isEmissionsLonger = delta > 0;
    let equalEmissions = emissionsSeries;
    if (isEmissionsLonger) {
      equalEmissions = emissionsSeries.slice(0, -delta);
    };

    return zipWith(
      distanceSeries,
      equalEmissions,
      (distance, emissions) => {
        return {
          autoRickshaw: {
            commercial: emissions.autoRickshaw.commercial * distance.autoRickshaw.commercial,
          },
          car: {
            commercial: emissions.car.commercial * distance.car.commercial,
            private: emissions.car.private * distance.car.private,

          },
          publicTransit: {
            bus: emissions.publicTransit.bus * distance.publicTransit.bus,
          },
          twoWheel: {
            commercial: emissions.twoWheel.commercial * distance.twoWheel.commercial,
            private: emissions.twoWheel.private * distance.twoWheel.private,
          }
        }
      }
    )
  }
)


export const getCNGEmissionsTotal = createSelector([
  getUtilizationCNG,
  getCNGEmissionsPerKm,
],
  (distanceSeries, emissionsSeries, ) => {

    // One of the series is longer than the other
    const delta = emissionsSeries.length - distanceSeries.length;
    const isEmissionsLonger = delta > 0;
    let equalEmissions = emissionsSeries;
    if (isEmissionsLonger) {
      equalEmissions = emissionsSeries.slice(0, -delta);
    };

    return zipWith(
      distanceSeries,
      equalEmissions,
      (distance, emissions) => {
        return {
          autoRickshaw: {
            commercial: emissions.autoRickshaw.commercial * distance.autoRickshaw.commercial,
          },
          car: {
            commercial: emissions.car.commercial * distance.car.commercial,
            private: emissions.car.private * distance.car.private,

          },
          publicTransit: {
            bus: emissions.publicTransit.bus * distance.publicTransit.bus,
          },
        }
      }
    )
  }
)

export const getDieselEmissionsTotal = createSelector([
  getUtilizationDiesel,
  getDieselEmissionsPerKm,
],
  (distanceSeries, emissionsSeries, ) => {

    // One of the series is longer than the other
    const delta = emissionsSeries.length - distanceSeries.length;
    const isEmissionsLonger = delta > 0;
    let equalEmissions = emissionsSeries;
    if (isEmissionsLonger) {
      equalEmissions = emissionsSeries.slice(0, -delta);
    };

    return zipWith(
      distanceSeries,
      equalEmissions,
      (distance, emissions) => {
        return {
          autoRickshaw: {
            commercial: emissions.autoRickshaw.commercial * distance.autoRickshaw.commercial,
          },
          car: {
            commercial: emissions.car.commercial * distance.car.commercial,
            private: emissions.car.private * distance.car.private,

          },
          publicTransit: {
            bus: emissions.publicTransit.bus * distance.publicTransit.bus,
          },
        }
      }
    )
  }
)



// WEBPACK FOOTER //
// ./src/store/selectors/carbonPollution/ice.ts